import { RateFastUpdateFormType } from './RateFastUpdateFormType';
import * as Yup from 'yup';
import { YupShape } from 'shared/models/YupShape';

export const validation: YupShape<RateFastUpdateFormType> = Yup.object().shape({
  expirationDate: Yup.mixed().required('La fecha es requerida'),
  porcentage: Yup.string().required('El porcentaje es Requerido')
});
